import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../config.service';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-create-selections-customer',
  templateUrl: './create-selections-customers.component.html',
  styleUrls: ['./create-selections-customers.component.scss']
})
export class CreateSelectionsCustomerComponent implements OnInit {


  constructor(
    private keycloakService: KeycloakService,
    private appConstants : AppConstants
  ) { }

  userInfo: any;
  async ngOnInit() {
    this.isLoading = true
      const user = this.appConstants.userDetails
      this.userInfo = user;
      this.sendCustomersSelectionsInfo();

  }

  sendToken: any = {};
  async getToken() {
    let token
    if (await this.keycloakService.isLoggedIn()) {
      token = await this.keycloakService.getToken();
      this.sendToken = Object.assign({}, {
        token: token
      })
    }
  }

  customersSelectionsInfo: any = {};
  sendCustomersSelectionsInfo() {
    let details = {
      endPoints: this.appConstants.endPoints,
      userInfo: this.userInfo,
    }
    this.customersSelectionsInfo = {...{}, ...details}
      this.getToken();
      setTimeout(() => {
        this.getToken();
      }, 1000);
  }

  isLoading : boolean = false
  loadingEvent(event){
    if(event && event.detail)
     this.isLoading = false
  }


}
